const translations = {
  'en-US': {
    'blog': '/blog/l/en-US',
    'veedgee': 'https://veedgee.compilorama.com/?locale=en-US'
  },
  'pt-BR': {
    'blog': '/blog/l/pt-BR',
    'veedgee': 'https://veedgee.compilorama.com/?locale=pt-BR'
  }
};

export default translations;
